module.exports = __webpack_public_path__ + "static/media/venmoLogo.c48fbf15.png";